import { CodigosTransaccionesConstant } from 'constants/index'

const listaItems = [
  {
    title: 'Ventas',
    submenu: [
      {
        page: CodigosTransaccionesConstant.VENTAS_LISTA,
        transaccion: CodigosTransaccionesConstant.VENTAS_LISTA,
        title: 'Ventas'
      },
      {
        page: CodigosTransaccionesConstant.VENTASRAPIDAS_LISTA,
        transaccion: CodigosTransaccionesConstant.VENTASRAPIDAS_LISTA,
        title: 'Ventas Rapidas'
      },
      {
        page: CodigosTransaccionesConstant.VENTAS_SINENTREGA_LISTA,
        transaccion: CodigosTransaccionesConstant.VENTAS_SINENTREGA_LISTA,
        title: 'Ventas Sin entrega'
      },
      {
        page: CodigosTransaccionesConstant.PREFACTURACIONES_LISTA,
        transaccion: CodigosTransaccionesConstant.PREFACTURACIONES_LISTA,
        title: 'Pre-Ventas'
      },
      {
        page: CodigosTransaccionesConstant.CONSULTAVENTAS_LISTA,
        transaccion: CodigosTransaccionesConstant.CONSULTAVENTAS_LISTA,
        title: 'Consulta Ventas'
      },
      {
        page: CodigosTransaccionesConstant.VENTASINGRESOGUIA_LISTA,
        transaccion: CodigosTransaccionesConstant.VENTASINGRESOGUIA_LISTA,
        title: 'Ingreso Guias para Ventas'
      },
      {
        page: CodigosTransaccionesConstant.VENTASINGRESOGUIA_YAEMITIDAS,
        transaccion: CodigosTransaccionesConstant.VENTASINGRESOGUIA_YAEMITIDAS,
        title: 'Ingreso Guias - Ya emitidas'
      },
      {
        submenu: [
          {
            page: CodigosTransaccionesConstant.COBRANZAS_NUEVO,
            title: 'Cobranzas',
            transaccion: CodigosTransaccionesConstant.COBRANZAS_NUEVO
          },
          {
            page: CodigosTransaccionesConstant.COBRANZAS_REPORTES,
            title: 'Reportes',
            transaccion: CodigosTransaccionesConstant.COBRANZAS_REPORTES
          }
        ],
        title: 'Cobranzas'
      },
      {
        page: CodigosTransaccionesConstant.VENTAS_DESVINCULARANTICIPO_LISTA,
        transaccion: CodigosTransaccionesConstant.VENTAS_DESVINCULARANTICIPO_LISTA,
        title: 'Desvincular Anticipos'
      },
      {
        page: CodigosTransaccionesConstant.CONSULTAGUIAS_LISTA,
        transaccion: CodigosTransaccionesConstant.CONSULTAGUIAS_LISTA,
        title: 'Consulta Guias'
      },
      {
        page: CodigosTransaccionesConstant.DARDEBAJA_MAIN,
        transaccion: CodigosTransaccionesConstant.DARDEBAJA_MAIN,
        title: 'Dar de baja'
      },
      {
        page: CodigosTransaccionesConstant.EMISORDOCUMENTOS_MAIN,
        transaccion: CodigosTransaccionesConstant.EMISORDOCUMENTOS_MAIN,
        title: 'Emisor Documentos'
      },
      {
        page: CodigosTransaccionesConstant.VENTASREPORTES_MAIN,
        transaccion: CodigosTransaccionesConstant.VENTASREPORTES_MAIN,
        title: 'Reportes'
      }
    ]
  },
  {
    submenu: [
      {
        page: CodigosTransaccionesConstant.COMPRAS_LISTA,
        transaccion: CodigosTransaccionesConstant.COMPRAS_LISTA,
        title: 'Compras'
      },
      {
        page: CodigosTransaccionesConstant.COMPRASGUIAS_LISTA,
        transaccion: CodigosTransaccionesConstant.COMPRASGUIAS_LISTA,
        title: 'Compras - Guias'
      },
      // {
      //   page: CodigosTransaccionesConstant.COMPRASINGRESOGUIA_LISTA,
      //   transaccion: CodigosTransaccionesConstant.COMPRASINGRESOGUIA_LISTA,
      //   title: 'Ingreso Guias'
      // },
      {
        submenu: [
          {
            page: CodigosTransaccionesConstant.ORDENESCOMPRAS_LISTA,
            transaccion: CodigosTransaccionesConstant.ORDENESCOMPRAS_LISTA,
            title: 'Ordenes Compra'
          }

          // {
          //   page: CodigosTransaccionesConstant.ORDENESCOMPRAS_CAMBIOESTADO_LISTA,
          //   transaccion: CodigosTransaccionesConstant.ORDENESCOMPRAS_CAMBIOESTADO_LISTA,
          //   title: 'Cambio Estado'
          // }
        ],
        title: 'Ordenes Compra'
      },
      {
        page: CodigosTransaccionesConstant.ORDENESCOMPRAS_APROBACION_LISTA,
        transaccion: CodigosTransaccionesConstant.ORDENESCOMPRAS_APROBACION_LISTA,
        title: 'Aprobación OC'
      },
      {
        page: CodigosTransaccionesConstant.COMPRASREPORTES_MAIN,
        transaccion: CodigosTransaccionesConstant.COMPRASREPORTES_MAIN,
        title: 'Reporte'
      }
    ],
    title: 'Compras'
  },
  // {
  //   title: 'Cotizaciones',
  //   submenu: [
  //     {
  //       page: CodigosTransaccionesConstant.COTIZACIONES_LISTA,
  //       transaccion: CodigosTransaccionesConstant.COTIZACIONES_LISTA,
  //       title: 'Cotizaciones'
  //     },
  //   ]
  // },
  {
    submenu: [
      {
        submenu: [
          {
            page: CodigosTransaccionesConstant.CONSULTAS_CONSUMOS,
            transaccion: CodigosTransaccionesConstant.CONSULTAS_CONSUMOS,
            title: 'Consumos'
          },
          {
            page: CodigosTransaccionesConstant.CONSULTAS_KARDEX,
            transaccion: CodigosTransaccionesConstant.CONSULTAS_KARDEX,
            title: 'Kardex'
          },
          {
            page: CodigosTransaccionesConstant.CONSULTAS_ENTRADASSALIDAS,
            transaccion: CodigosTransaccionesConstant.CONSULTAS_ENTRADASSALIDAS,
            title: 'Entradas - Salidas'
          }
        ],
        title: 'Consultas'
      },
      {
        submenu: [
          {
            page: CodigosTransaccionesConstant.TRANSFERENCIAS_ENTRADA_LISTA,
            transaccion: CodigosTransaccionesConstant.TRANSFERENCIAS_ENTRADA_LISTA,
            title: 'Por Entrada'
          },

          {
            page: CodigosTransaccionesConstant.TRANSFERENCIAS_SALIDA_LISTA,
            transaccion: CodigosTransaccionesConstant.TRANSFERENCIAS_SALIDA_LISTA,
            title: 'Por Salida'
          },
          {
            page: CodigosTransaccionesConstant.TRANSFERENCIAS_REPORTE,
            transaccion: CodigosTransaccionesConstant.TRANSFERENCIAS_REPORTE,
            title: 'Reporte'
          }
        ],
        title: 'Transferencias'
      },
      {
        submenu: [
          {
            page: CodigosTransaccionesConstant.INVENTARIOS_INGRESOMANUAL_LISTA,
            transaccion: CodigosTransaccionesConstant.INVENTARIOS_INGRESOMANUAL_LISTA,
            title: 'Ingreso Manual'
          },

          {
            page: CodigosTransaccionesConstant.INVENTARIOS_INGRESOMASIVO_MAIN,
            transaccion: CodigosTransaccionesConstant.INVENTARIOS_INGRESOMASIVO_MAIN,
            title: 'Ingreso Masivo'
          },

          {
            page: CodigosTransaccionesConstant.INVENTARIOS_PROCESAMIENTO_MAIN,
            transaccion: CodigosTransaccionesConstant.INVENTARIOS_PROCESAMIENTO_MAIN,
            title: 'Procesamiento'
          }
        ],
        title: 'Ingreso Fisico'
      },

      // {
      //   submenu: [
      //     {
      //       page: CodigosTransaccionesConstant.FORMULAS_REGISTRO_MAIN,
      //       transaccion: CodigosTransaccionesConstant.FORMULAS_REGISTRO_MAIN,
      //       title: 'Registro'
      //     },

      //     {
      //       page: CodigosTransaccionesConstant.FORMULAS_SALIDA_LISTA,
      //       transaccion: CodigosTransaccionesConstant.FORMULAS_SALIDA_LISTA,
      //       title: 'Salida'
      //     }
      //   ],
      //   title: 'Formulas'
      // },
      {
        page: CodigosTransaccionesConstant.SALDOSINICIALES_LISTA,
        transaccion: CodigosTransaccionesConstant.SALDOSINICIALES_LISTA,
        title: 'Saldos Iniciales'
      },
      {
        page: CodigosTransaccionesConstant.INVENTARIOS_ENTRADASALIDA_LISTA,
        transaccion: CodigosTransaccionesConstant.INVENTARIOS_ENTRADASALIDA_LISTA,
        title: 'Entradas - Salidas'
      },
      {
        page: CodigosTransaccionesConstant.INGRESOALMACENPORODENCOMPRA_LISTA,
        transaccion: CodigosTransaccionesConstant.INGRESOALMACENPORODENCOMPRA_LISTA,
        title: 'Ingreso almacen - OC'
      },
      {
        page: CodigosTransaccionesConstant.ALMACENES_LISTA,
        transaccion: CodigosTransaccionesConstant.ALMACENES_LISTA,
        title: 'Almacenes'
      },
      {
        page: CodigosTransaccionesConstant.INVENTARIOS_OPERACIONES_MAIN,
        transaccion: CodigosTransaccionesConstant.INVENTARIOS_OPERACIONES_MAIN,
        title: 'Operaciones'
      }
    ],
    title: 'Inventarios'
  },
  {
    title: 'Reportes',
    submenu: [
      {
        page: `${CodigosTransaccionesConstant.INVENTARIOS_REPORTES_MAIN}/formato-12-1`,
        transaccion: CodigosTransaccionesConstant.INVENTARIOS_REPORTES_MAIN,
        title: 'Formato 12.1'
      },
      {
        page: `${CodigosTransaccionesConstant.INVENTARIOS_REPORTES_MAIN}/formato-13-1`,
        transaccion: CodigosTransaccionesConstant.INVENTARIOS_REPORTES_MAIN,
        title: 'Formato 13.1'
      },
      {
        page: `${CodigosTransaccionesConstant.INVENTARIOS_REPORTES_MAIN}/formato-3-7`,
        transaccion: CodigosTransaccionesConstant.INVENTARIOS_REPORTES_MAIN,
        title: 'Formato 3.7'
      },
      {
        page: `${CodigosTransaccionesConstant.INVENTARIOS_REPORTES_MAIN}/tipo-operacion`,
        transaccion: CodigosTransaccionesConstant.INVENTARIOS_REPORTES_MAIN,
        title: 'Tipo Operación'
      },
      {
        page: `${CodigosTransaccionesConstant.INVENTARIOS_REPORTES_MAIN}/cruce-compras`,
        transaccion: CodigosTransaccionesConstant.INVENTARIOS_REPORTES_MAIN,
        title: 'Cruce Compras-Kardex'
      },
      {
        page: `${CodigosTransaccionesConstant.INVENTARIOS_REPORTES_MAIN}/transferencias`,
        transaccion: CodigosTransaccionesConstant.INVENTARIOS_REPORTES_MAIN,
        title: 'Transferencias'
      },
      {
        page: `${CodigosTransaccionesConstant.INVENTARIOS_REPORTES_MAIN}/stock-general`,
        transaccion: CodigosTransaccionesConstant.INVENTARIOS_REPORTES_MAIN,
        title: 'Stock General'
      },
      {
        page: CodigosTransaccionesConstant.INVENTARIOS_REPORTES_MAIN,
        transaccion: CodigosTransaccionesConstant.INVENTARIOS_REPORTES_MAIN,
        title: 'Otros Reportes'
      }
    ]
  },
  {
    page: CodigosTransaccionesConstant.BACKGROUNDJOBS_MAIN,
    transaccion: CodigosTransaccionesConstant.BACKGROUNDJOBS_MAIN,
    title: 'Procesos BG'
  },
  {
    submenu: [
      {
        page: CodigosTransaccionesConstant.REQUERIMIENTOS_LISTA,
        transaccion: CodigosTransaccionesConstant.REQUERIMIENTOS_LISTA,
        title: 'Requerimientos'
      },
      {
        page: CodigosTransaccionesConstant.REQUERIMIENTOS_EVALUACION,
        transaccion: CodigosTransaccionesConstant.REQUERIMIENTOS_EVALUACION,
        title: 'Evaluacion'
      }
    ],
    title: 'Requerimientos'
  },
  {
    page: CodigosTransaccionesConstant.ALMACEN_GESTION_ENTREGAS,
    transaccion: CodigosTransaccionesConstant.ALMACEN_GESTION_ENTREGAS,
    title: 'Almacén · Entregas'
  },
  {
    submenu: [
      {
        page: CodigosTransaccionesConstant.PRODUCTOS_LISTA,
        transaccion: CodigosTransaccionesConstant.PRODUCTOS_LISTA,
        title: 'Productos'
      },
      {
        page: CodigosTransaccionesConstant.PRECIOS_MAIN,
        transaccion: CodigosTransaccionesConstant.PRECIOS_MAIN,
        title: 'Precios'
      },
      {
        page: CodigosTransaccionesConstant.PROMOCIONES_LISTA,
        transaccion: CodigosTransaccionesConstant.PROMOCIONES_LISTA,
        title: 'Promociones'
      },
      {
        page: CodigosTransaccionesConstant.SOCIOS_LISTA,
        transaccion: CodigosTransaccionesConstant.SOCIOS_LISTA,
        title: 'Socios'
      },
      {
        page: CodigosTransaccionesConstant.SOCIOSSEGUIMIENTO_MAIN,
        transaccion: CodigosTransaccionesConstant.SOCIOSSEGUIMIENTO_MAIN,
        title: 'Socios - Seguimiento'
      },
      {
        title: 'Otros',
        submenu: [
          {
            page: CodigosTransaccionesConstant.TABLASCOMUNES_MAIN,
            transaccion: CodigosTransaccionesConstant.TABLASCOMUNES_MAIN,
            title: 'Tablas Comunes'
          },
          {
            title: 'Tablas Personalizadas',
            page: CodigosTransaccionesConstant.TABLASPERSONALIZADAS_MAIN,
            transaccion: CodigosTransaccionesConstant.TABLASPERSONALIZADAS_MAIN,
            bullet: 'dot'
          },
          {
            title: 'Oficinas',
            page: `${CodigosTransaccionesConstant.TABLASPERSONALIZADAS_UNICO}/TP025`,
            transaccion: CodigosTransaccionesConstant.TABLASPERSONALIZADAS_MAIN,
            bullet: 'dot'
          },
          {
            title: 'Categorias',
            page: CodigosTransaccionesConstant.CATEGORIAS_LISTA,
            transaccion: CodigosTransaccionesConstant.CATEGORIAS_LISTA,
            bullet: 'dot'
          },
          {
            title: 'Marcas',
            page: CodigosTransaccionesConstant.MARCAS_LISTA,
            transaccion: CodigosTransaccionesConstant.MARCAS_LISTA,
            bullet: 'dot'
          },
          {
            title: 'Familias',
            page: CodigosTransaccionesConstant.FAMILIAS_LISTA,
            transaccion: CodigosTransaccionesConstant.FAMILIAS_LISTA,
            bullet: 'dot'
          },
          {
            title: 'SubFamilias',
            page: CodigosTransaccionesConstant.SUBFAMILIAS_LISTA,
            transaccion: CodigosTransaccionesConstant.SUBFAMILIAS_LISTA,
            bullet: 'dot'
          },
          {
            title: 'Plantillas Cabecera-Pie',
            page: CodigosTransaccionesConstant.PLANTILLAS_CABECERA_PIE_MAIN,
            transaccion: CodigosTransaccionesConstant.PLANTILLAS_CABECERA_PIE_MAIN,
            bullet: 'dot'
          },
          {
            title: 'Ubic Almacenamiento',
            page: CodigosTransaccionesConstant.UBICACIONESALMACENAMIENTO_LISTA,
            transaccion: CodigosTransaccionesConstant.UBICACIONESALMACENAMIENTO_LISTA,
            bullet: 'dot'
          }
        ]
      },
      {
        title: 'Admin',
        submenu: [
          {
            page: CodigosTransaccionesConstant.COMPANIA_MAIN,
            transaccion: CodigosTransaccionesConstant.COMPANIA_MAIN,
            title: 'Compania'
          },
          {
            page: CodigosTransaccionesConstant.SEDES_LISTA,
            transaccion: CodigosTransaccionesConstant.SEDES_LISTA,
            title: 'Establecimientos'
          },
          {
            title: 'Series',
            page: CodigosTransaccionesConstant.SERIES_LISTA,
            transaccion: CodigosTransaccionesConstant.SERIES_LISTA,
            bullet: 'dot'
          },
          {
            title: 'Roles',
            page: CodigosTransaccionesConstant.ROLES_LISTA,
            transaccion: CodigosTransaccionesConstant.ROLES_LISTA,
            bullet: 'dot'
          },
          {
            page: CodigosTransaccionesConstant.USUARIOS_LISTA,
            transaccion: CodigosTransaccionesConstant.USUARIOS_LISTA,
            title: 'Usuarios'
          },
          {
            title: 'Transacciones',
            page: CodigosTransaccionesConstant.TRANSACCIONES_LISTA,
            transaccion: CodigosTransaccionesConstant.TRANSACCIONES_LISTA,
            bullet: 'dot'
          }
        ]
      }
    ],

    title: 'Mantenimiento'
  },
  {
    submenu: [
      {
        page: CodigosTransaccionesConstant.EGRESOSINGRESOS_LISTA,
        transaccion: CodigosTransaccionesConstant.EGRESOSINGRESOS_LISTA,
        title: 'Egreso - Ingreso'
      }
    ],
    title: 'Caja'
  },
  {
    title: 'Talleres',
    submenu: [
      {
        page: CodigosTransaccionesConstant.TALLERES_LISTA,
        transaccion: CodigosTransaccionesConstant.TALLERES_LISTA,
        title: 'Talleres'
      },
      {
        page: CodigosTransaccionesConstant.TALLERES_ANALISIS_REPORTE,
        transaccion: CodigosTransaccionesConstant.TALLERES_ANALISIS_REPORTE,
        title: 'Análisis de Reporte'
      }
    ]
  },
  {
    title: 'Turnos',
    submenu: [
      {
        page: CodigosTransaccionesConstant.TURNOS_LISTA,
        transaccion: CodigosTransaccionesConstant.TURNOS_LISTA,
        title: 'Turnos'
      },
      {
        page: CodigosTransaccionesConstant.TURNOS_CAMBIARISLA,
        transaccion: CodigosTransaccionesConstant.TURNOS_CAMBIARISLA,
        title: 'Cambiar isla'
      },
      {
        page: CodigosTransaccionesConstant.TURNOS_ABRIR,
        transaccion: CodigosTransaccionesConstant.TURNOS_ABRIR,
        title: 'Abrir'
      },
      {
        page: CodigosTransaccionesConstant.TURNOS_CERRAR,
        transaccion: CodigosTransaccionesConstant.TURNOS_CERRAR,
        title: 'Cerrar'
      }
    ]
  },
  {
    title: 'Grifo',
    submenu: [
      {
        page: CodigosTransaccionesConstant.ISLAS_CONTROL,
        transaccion: CodigosTransaccionesConstant.ISLAS_CONTROL,
        title: 'Islas - Control'
      },
      {
        page: CodigosTransaccionesConstant.ISLAS_CUADRESCOMBUSTIBLES,
        transaccion: CodigosTransaccionesConstant.ISLAS_CUADRESCOMBUSTIBLES,
        title: 'Cuadres Combustibles'
      }
    ]
  }
]

export default listaItems
